import type { VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'vue';

import { cva } from 'class-variance-authority';

export { default as FavoriteButton } from './FavoriteButton.vue';

export const favoriteButtonVariants = cva(
	'flex size-8 shrink-0 items-center justify-center rounded-[100px] p-1 shadow-[0_1px_3px_1px_rgba(0,0,0,0.15)] transition-colors duration-300',
	{
		variants: {
			state: {
				inactive:
					'border-white bg-white text-primary hover:border-white-dark-3 hover:bg-white-dark-3 focus:border-white-dark-3',
				active:
					'border-beige bg-beige text-primary hover:border-beige hover:bg-beige focus:border-beige'
			}
		},
		defaultVariants: {
			state: 'inactive'
		}
	}
);

export type FavoriteButtonVariants = VariantProps<
	typeof favoriteButtonVariants
>;

export interface FavoriteButtonProps {
	class?: HTMLAttributes['class'];
	isFavorite?: boolean;
	ariaLabel?: string;
	propertyId: string;
	commercialId: string;
}
